import {
  bannerBrightness,
  bannerOverlayStyle,
} from '../../shared/bannerOverlay';
import './Footer.scss';
import { Link, useLocation } from 'react-router-dom';
import logo from '../../assets/media-manager-logo.webp';
import { useGetRandomMovieQuery } from '../../app/services/movieServerApi';
import { useGetRandomEpisodeQuery } from '../../app/services/tvShowServerApi';
import { useGetRandomAutographQuery } from '../../app/services/autographServerApi';
import { useEffect, useState } from 'react';
import { useAppSelector } from '../../app/hooks';
import { RootState } from '../../app/store';

export const Footer = () => {
  const location = useLocation();

  const [skipGetRandomMovieItem, setSkipGetRandomMovieItem] = useState(true);
  const [skipGetRandomEpisodeItem, setSkipGetRandomEpisodeItem] =
    useState(true);
  const [skipGetRandomAutographItem, setSkipGetRandomAutographItem] =
    useState(true);

  const newMovieBackground = useAppSelector(
    (state: RootState) => state.addMedia.newMovieBackground,
  );

  const newMovieBackgroundVerticalPosition = useAppSelector(
    (state: RootState) => state.addMedia.newMovieBackgroundVerticalPosition,
  );

  const newEpisodeBackground = useAppSelector(
    (state: RootState) => state.addTvShowSeasonEpisode.newEpisodeBackground,
  );

  const newEpisodeBackgroundVerticalPosition = useAppSelector(
    (state: RootState) =>
      state.addTvShowSeasonEpisode.newEpisodeBackgroundVerticalPosition,
  );

  const newAutographBackground = useAppSelector(
    (state: RootState) => state.addAutograph.newAutographBackground,
  );

  const newAutographBackgroundVerticalPosition = useAppSelector(
    (state: RootState) =>
      state.addAutograph.newAutographBackgroundVerticalPosition,
  );

  const {
    data: movieItem = undefined,
    // isLoading: isLoadingMovieItem,
    // // isFetching,
    // isError: isErrorMovieItem,
    // error: errorMovieItem,
  } = useGetRandomMovieQuery(
    { mode: 'background' },
    {
      skip: skipGetRandomMovieItem,
    },
  );
  const {
    data: episodeItem = undefined,
    // isLoading: isLoadingEpisodeItem,
    // // isFetching,
    // isError: isErrorEpisodeItem,
    // error: errorEpisodeItem,
  } = useGetRandomEpisodeQuery(
    { mode: 'background' },
    {
      skip: skipGetRandomEpisodeItem,
    },
  );
  const {
    data: autographItem = undefined,
    // isLoading: isLoadingAutographItem,
    // // isFetching,
    // isError: isErrorAutographItem,
    // error: errorAutographItem,
  } = useGetRandomAutographQuery(
    { mode: 'background' },
    {
      skip: skipGetRandomAutographItem,
    },
  );
  let randomItem = undefined;

  if (location.pathname.includes('autographs')) {
    randomItem = autographItem?.footer;
  } else if (location.pathname.includes('tv-shows')) {
    randomItem = episodeItem?.footer;
  } else if (!location.pathname.includes('add-media')) {
    randomItem = movieItem?.footer;
  }

  useEffect(() => {
    if (location.pathname.includes('autographs')) {
      // eslint-disable-next-line react-hooks/set-state-in-effect -- pre-existing, tracked for a dedicated follow-up fix
      setSkipGetRandomAutographItem(false);
    } else if (location.pathname.includes('tv-shows')) {
      setSkipGetRandomEpisodeItem(false);
    } else if (!location.pathname.includes('add-media')) {
      setSkipGetRandomMovieItem(false);
    }
  }, [location.pathname]);

  const [loaded, setLoaded] = useState(false);
  const handleLoad = () => {
    setLoaded(true);
  };

  const background = randomItem?.background
    ? randomItem?.background
    : randomItem?.cover
      ? randomItem?.cover
      : randomItem?.image;

  const newMediaBackground =
    newMovieBackground !== ''
      ? newMovieBackground
      : newEpisodeBackground !== ''
        ? newEpisodeBackground
        : newAutographBackground;
  const newMediaBackgroundVerticalPosition =
    newMovieBackground !== ''
      ? newMovieBackgroundVerticalPosition
      : newEpisodeBackground !== ''
        ? newEpisodeBackgroundVerticalPosition
        : newAutographBackgroundVerticalPosition;

  return (
    <div
      className="media-footer"
      style={{
        // The same dimming the banners get. The scrim is here so the
        // text over it stays readable, and a flat one leaves an
        // already-dark still barely visible - so it is set from the
        // measured brightness of whichever image this actually ended
        // up showing. An unmeasured one keeps the old fixed value.
        ...bannerOverlayStyle(bannerBrightness(randomItem)),
        backgroundImage: loaded
          ? `url(${background ?? newMediaBackground})`
          : undefined,
        backgroundPosition: `${randomItem?.backgroundHorizontalPosition ?? 50}% ${randomItem?.backgroundVerticalPosition ?? newMediaBackgroundVerticalPosition}%`,
      }}
    >
      <img
        src={background ?? newMediaBackground}
        alt=""
        onLoad={handleLoad}
        style={{ display: 'none' }}
      />
      <div className="media-footer__content detail-container">
        <div className="media-footer__content__logo">
          <div className="media-logo-footer">
            <img src={logo} alt="media-manager-logo" />
            <Link className="media-a" to="/">
              MediaManager
            </Link>
          </div>
        </div>
        {/* <div className="media-footer__content__menus">
          <div className="media-footer__content__menu">
            <Link className="media-a" to="/">
              Home
            </Link>
          </div>
          <div className="media-footer__content__menu">
            <Link className="media-a" to="/">
              Live
            </Link>
          </div>
          <div className="media-footer__content__menu">
            <Link className="media-a" to="/">
              You must watch
            </Link>
          </div>
        </div> */}
      </div>
    </div>
  );
};
